import { createReducer } from '@reduxjs/toolkit';

import createMiddleware from '../../core/createMiddleware';

import { NotificationModule, NotificationState } from './types';
import { notificationDisappeared, notificationAppeared } from './events';

const notificationsModule: NotificationModule = () => ({
  name: 'notifications',
  reducer: createReducer([] as NotificationState, (builder) =>
    builder
      .addCase(
        notificationAppeared,
        (
          state,
          {
            payload: { id, message, type, withTranslation, translationOptions },
          },
        ) => [
          ...state,
          {
            id,
            message,
            type,
            withTranslation,
            translationOptions,
          },
        ],
      )
      .addCase(notificationDisappeared, (state, { payload: id }) =>
        state.filter((notification) => notification.id !== id),
      ),
  ),
  middleware: [
    createMiddleware(notificationAppeared, ({ id, timeout }, { dispatch }) => {
      if (timeout) {
        setTimeout(() => {
          dispatch(notificationDisappeared(id));
        }, timeout);
      }
    }),
  ],
  api: {
    handleClose: ({ id }, { dispatch }) => {
      dispatch(notificationDisappeared(id));
    },
  },
});

export default notificationsModule;
